import { render, staticRenderFns } from "./exchangeList.vue?vue&type=template&id=2cdae3bd"
import script from "./exchangeList.vue?vue&type=script&lang=js"
export * from "./exchangeList.vue?vue&type=script&lang=js"
import style0 from "./exchangeList.vue?vue&type=style&index=0&id=2cdae3bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports